module.exports = __webpack_public_path__ + "img/ghana.6be38efa.svg";